import { MixedSchema, RawInlineNodes } from '@principle-theorem/editor';
import {
  AtLeast,
  IDeleteAfter,
  ISoftDelete,
  toTimestamp,
  uid,
} from '@principle-theorem/shared';
import * as moment from 'moment-timezone';

export interface IPopupNotificationAction {
  label: string;
  href: string | string[];
  fragment?: string;
  queryParams?: Record<string, string | string[]>;
  colour?: 'primary' | 'accent' | 'warn';
  style?: 'stroked' | 'flat';
}

export interface IPopupNotification extends ISoftDelete, IDeleteAfter {
  uid: string;
  groupId: string;
  title: string | RawInlineNodes;
  content: string | MixedSchema;
  hasTimeout: boolean;
  notificationSound?: string;
  actions: IPopupNotificationAction[];
}

export class PopupNotification {
  static init(
    overrides: AtLeast<IPopupNotification, 'title' | 'content'>
  ): IPopupNotification {
    return {
      uid: uid(),
      groupId: uid(),
      hasTimeout: true,
      actions: [],
      deleteAfter: toTimestamp(moment().add(3, 'days')),
      deleted: false,
      ...overrides,
    };
  }
}
